module.exports = "/v2/pages/dashboard/dist/cdf3e184b2cae44113a288616d421078.svg";